import InViewport from './modules/InViewport'
import Header from './modules/Header'
import Images from './modules/Images'
import Newsletter from './modules/Newsletter'
import MenuDrawer from './modules/MenuDrawer'
import Contact from './modules/Contact'

InViewport();
Header();
Images();
Newsletter();
MenuDrawer();
Contact();